
const yuklemeTuruOptionsFilter = [
    {
        value: 0,
        text: "Hepsi",
    },
    {
        value: 1,
        text: "LTL(Parsiyel)"
    },
    {
        value: 2,
        text: "FTL(Komple)"
    },
]


export default yuklemeTuruOptionsFilter